import { render, staticRenderFns } from "./MenuOther.vue?vue&type=template&id=3fc507a0&scoped=true&"
import script from "./MenuOther.vue?vue&type=script&lang=js&"
export * from "./MenuOther.vue?vue&type=script&lang=js&"
import style0 from "./MenuOther.vue?vue&type=style&index=0&id=3fc507a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc507a0",
  null
  
)

export default component.exports